<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Configure SSO</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!statusSucceed && organizationId" class="container">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="onlyPasswords" v-model="authMode" name="authMode" class="custom-control-input" value="onlyPasswords">
                <label class="custom-control-label" for="onlyPasswords">Passwords only</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="mixed" v-model="authMode" name="authMode" class="custom-control-input" value="mixed">
                <label class="custom-control-label" for="mixed">Mixed (passwords and SSO)</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="onlySso" v-model="authMode" name="authMode" class="custom-control-input" value="onlySso">
                <label class="custom-control-label" for="onlySso">SSO only</label>
            </div>

            <div v-show="ssoSettingsVisible">
                <hr />

                <div class="alert alert-warning" role="alert">
                    Only OAuth2 based SSO is supported.
                </div>

                <div v-if="signInUrl" class="alert alert-primary" role="alert">
                    Users can follow this link to sign in with your SSO provider:<br />
                    <a :href="signInUrl" target="_blank">{{signInUrl}}</a>
                </div>

                <div class="form-group">
                    <label>OAuth2 client ID:</label>
                    <input v-model="clientId" type="text" class="form-control">
                </div>

                <div class="form-group">
                    <label>OAuth2 client secret:</label>
                    <input v-model="clientSecret" type="password" class="form-control">
                </div>

                <div class="form-group">
                    <label>OAuth2 token endpoint uri:</label>
                    <input v-model="tokenEndpointUri" type="text" class="form-control">
                </div>

                <div class="form-group">
                    <label>OAuth2 authorization endpoint uri:</label>
                    <input v-model="authorizationEndpointUri" type="text" class="form-control">
                </div>

                <button v-show="statusInitial || statusInvalid" @click="handleConfigureOauth2CommandV1" type="button" class="btn btn-primary btn-lg">Save</button>
                <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Saving...</button>
            </div>
        </div>

        <div v-else-if="statusSucceed" class="container">
            <h4>Congratulation! OAuth2 based SSO was configured.</h4>
            <a class="btn btn-primary btn-lg" :href="`/#/admin/organizations/dashboard/${tid}`" role="button">Go to dashboard</a>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import VuePageQueries from "@Organizations/OrganizationUnits/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/OrganizationUnits/Domain/commands-vue-component";

    @Component({
        watch: {
            ssoConfigurationModel: 'ssoConfigurationModelChanged'
        }
    })
    export default class ManageOrganizationSsoPage extends mixins(PageBase, PageStatus, VuePageQueries, VuePageCommands) {
        clientId = '';
        clientSecret = '';
        tokenEndpointUri = '';
        authorizationEndpointUri = '';
        authMode = 'onlyPasswords';

        get ssoConfigurationModel() { return this.model?.SsoConfiguration; }
        get organizationId() { return this.ssoConfigurationModel?.Id; }
        get signInUrl() { return this.ssoConfigurationModel?.SignInUrl; }
        get ssoSettingsVisible() { return this.authMode == 'mixed' || this.authMode == 'onlySso' }

        mounted() {
            this.setTitle('Configure SSO');
            this.runSsoConfigurationQueryV1(this.tid);
        }

        //@Watch('ssoConfigurationModel')
        ssoConfigurationModelChanged(ssoConfigurationModel) {
            if (ssoConfigurationModel) {
                this.clientId = ssoConfigurationModel.ClientId;
                this.clientSecret = ssoConfigurationModel.ClientSecret;
                this.tokenEndpointUri = ssoConfigurationModel.TokenEndpointUri;
                this.authorizationEndpointUri = ssoConfigurationModel.AuthorizationEndpointUri;
            }
        }

        handleConfigureOauth2CommandV1() {
            this.setStatusInvoking();
            this.$clearValidationErrors();
            this.invokeConfigureOauth2CommandV1(this.organizationId, this.clientId, this.clientSecret, this.tokenEndpointUri, this.authorizationEndpointUri);
        }

        succeedConfigureOauth2CommandV1() {
            this.setStatusSucceed();
        }

        invalidConfigureOauth2CommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        failedConfigureOauth2CommandV1(status) {
            this.setStatusFailed();
        }
    }
</script>